import { fromFetch } from 'rxjs/fetch';
import { z } from 'zod/v4';

import { AuthHeaders } from '../../../models/auth-headers';
import { dataAccessEnvironment } from '../../../models/data-access-environment';
import { requiredHeaders } from '../../../models/required-headers';
import { selectData } from '../../../utils/select-data';
import { withJwt } from '../../../utils/with-jwt';
import { accountsEnvironment } from '../accounts-environment';
import { userSchema } from '../schemas/user.schema';

const requestSchema = z.array(
  userSchema.pick({
    externalId: true,
  })
);

/**
 * Remove all product licenses from a list of Users
 * @param request Array of User External IDs
 * @returns A Data object indicating success
 */
export function deleteLicenseBulkUnassign(
  this: unknown,
  request: z.infer<typeof requestSchema>
) {
  return withJwt((jwtAuthHeaders) =>
    fromFetch(
      new Request(
        `${accountsEnvironment.resolve(this).licenseUrl}/bulk/unassign`,
        {
          method: 'DELETE',
          headers: {
            ...requiredHeaders,
            ...(dataAccessEnvironment.configuration.useLegacyTokenForAccountsApi
              ? new AuthHeaders()
              : jwtAuthHeaders),
          },
          body: JSON.stringify(request),
        }
      )
    )
  ).pipe(
    selectData(
      z.object({
        assetsWithNoLicense: z.array(z.string()),
      })
    )
  );
}
